import { PathModule } from "app/common/LocalConst";
import { EgretLoadable } from "egret";

const ReportRouter = {
  path: PathModule.REPORT,
  exact: true,
  children: [
    
  ],
};

export default ReportRouter;
